import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const traxo = defineConnector({
  identifier: "traxo",
  name: "Traxo",
  tagLine: "Corporate travel booking data capture",
  keywords: "traxo travel data capture trips segments itineraries bookings",
  logo,
  protocol: "http",
  tags: ["travel"],
  defaultUrlPattern: () => domainToRegex("api.traxo.com/v2"),
  auth: oauthAuth,
  steps: [
    {
      title: "Get Traxo API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Request a developer application from Traxo at [developer.traxo.com](https://developer.traxo.com/) — the standard tier is provisioned with a client ID and secret. Programmatic user management and long-lived server tokens are premium features, granted by emailing api-support@traxo.com with your client ID.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://www.traxo.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.traxo.com/v2/me",
  },
});
